import { AlertTriangle } from "lucide-react";
import { ApiError } from "@/lib/api";
import { Button } from "./Button";

export function ErrorState({
  error,
  onRetry,
}: {
  error: unknown;
  onRetry?: () => void;
}) {
  const message =
    error instanceof ApiError
      ? `[${error.code}] ${error.message}`
      : error instanceof Error
        ? error.message
        : "Error desconocido";
  const is401 = error instanceof ApiError && error.status === 401;

  return (
    <div className="flex flex-col items-center text-center py-10 px-4">
      <AlertTriangle className="h-8 w-8 text-amber-500" />
      <p className="mt-2 text-sm font-medium text-slate-900">
        {is401 ? "Sesión inválida o expirada" : "Algo salió mal"}
      </p>
      <p className="mt-1 text-xs text-slate-500 max-w-md">{message}</p>
      {onRetry && (
        <Button className="mt-4" variant="outline" size="sm" onClick={onRetry}>
          Reintentar
        </Button>
      )}
    </div>
  );
}
